var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.specialties,"label":_vm.labelText,"clearable":"","dense":"","outlined":"","hide-details":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedSpecialty),callback:function ($$v) {_vm.selectedSpecialty=$$v},expression:"selectedSpecialty"}})
}
var staticRenderFns = []

export { render, staticRenderFns }